import React, { useContext } from 'react';
import { Colors } from '@app/theme';

const PricingColorContext = React.createContext<Colors>('blue');

export const ColorContextProvider = PricingColorContext.Provider;
export const usePricingColor = () => {
  return useContext(PricingColorContext);
};
